import { render, staticRenderFns } from "./ThirdPartyCode.vue?vue&type=template&id=60b271de&scoped=true"
import script from "./ThirdPartyCode.vue?vue&type=script&lang=js"
export * from "./ThirdPartyCode.vue?vue&type=script&lang=js"
import style0 from "./ThirdPartyCode.vue?vue&type=style&index=0&id=60b271de&prod&scoped=true&lang=css"
import style1 from "./ThirdPartyCode.vue?vue&type=style&index=1&id=60b271de&prod&lang=css"
import style2 from "./ThirdPartyCode.vue?vue&type=style&index=2&id=60b271de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b271de",
  null
  
)

export default component.exports